import { defineComponent as _defineComponent } from 'vue'
import { __ } from 'bits/intl'
import OzPlainButton, { OzPlainButtonSizePreset } from 'library/v4/components/OzPlainButton.vue'
import { storeToRefs } from 'pinia'
import { ref, watch } from 'vue'
import OzMultilineInput from '@@/library/v4/components/OzMultilineInput.vue'
import { useSurfaceShareLinksStore } from '@@/pinia/surface_share_links'


export default /*#__PURE__*/_defineComponent({
  __name: 'SurfaceSharePanelSubmissionRequestConfirmationText',
  setup(__props) {

const surfaceShareLinksStore = useSurfaceShareLinksStore()
const { submissionRequestConfirmationText } = storeToRefs(surfaceShareLinksStore)
const isConfirmationTextInputFocused = ref(false)
const confirmationText = ref(submissionRequestConfirmationText.value ?? '')
const confirmationTextInputRef = ref<InstanceType<typeof OzMultilineInput>>()

function updateConfirmationTextInput(e: Event): void {
  const input = (e.currentTarget as HTMLInputElement).value
  confirmationText.value = input
}

function saveConfirmationText(): void {
  confirmationTextInputRef.value?.blur()
  shouldDisplayInEditMode.value = false
  confirmationText.value = confirmationText.value.trim()
  surfaceShareLinksStore.enqueueUpdateSubmissionConfirmationText(confirmationText.value)
}

function handleFocusConfirmationTextInput(): void {
  shouldDisplayInEditMode.value = true
  isConfirmationTextInputFocused.value = true
}

function handleFocusOutConfirmationTextInput(event: FocusEvent): void {
  // If tabbing to the save button, don't save the confirmation text yet
  if (event.relatedTarget === saveButtonRef.value?.$el) return
  saveConfirmationText()
}

function handleBlurConfirmationTextInput(): void {
  shouldDisplayInEditMode.value = false
  isConfirmationTextInputFocused.value = false
}

function blurConfirmationTextInput(): void {
  handleBlurConfirmationTextInput()
  confirmationTextInputRef.value?.blur()
}

const saveButtonRef = ref<InstanceType<typeof OzPlainButton>>()
const shouldDisplayInEditMode = ref(false)

function handleBlurForSaveButton(event: FocusEvent): void {
  // If tabbing to the input field, don't save the confirmation text yet
  if (event.relatedTarget === confirmationTextInputRef.value?.$el) return
  saveConfirmationText()
}

watch(
  submissionRequestConfirmationText,
  () => {
    // watch value here as it can be updated from the backend after sanitizing
    if (submissionRequestConfirmationText.value !== confirmationText.value) {
      confirmationText.value = submissionRequestConfirmationText.value ?? ''
    }
  },
  { immediate: true },
)

return { __sfc: true,surfaceShareLinksStore, submissionRequestConfirmationText, isConfirmationTextInputFocused, confirmationText, confirmationTextInputRef, updateConfirmationTextInput, saveConfirmationText, handleFocusConfirmationTextInput, handleFocusOutConfirmationTextInput, handleBlurConfirmationTextInput, blurConfirmationTextInput, saveButtonRef, shouldDisplayInEditMode, handleBlurForSaveButton, __, OzPlainButton, OzPlainButtonSizePreset, OzMultilineInput }
}

})